import { render, staticRenderFns } from "./DoneMessage.vue?vue&type=template&id=49315fae&scoped=true&"
import script from "./DoneMessage.vue?vue&type=script&lang=js&"
export * from "./DoneMessage.vue?vue&type=script&lang=js&"
import style0 from "./DoneMessage.vue?vue&type=style&index=0&id=49315fae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49315fae",
  null
  
)

export default component.exports